import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Maryland = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Maryland Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure/Disclaimer Statement: Sellers must provide one of these.
        </Text>

        <Text style={styles.listItem}>
          2. HOA/Condo Association Disclosure: Required if applicable.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Residential Property Disclosure and Disclaimer Statement
          </Text>{' '}
          – Sellers must provide a disclosure form regarding the property's
          condition and defects before the buyer signs the purchase agreement.
        </Text>
      </View>
    </View>
  );
};

export default Maryland;
